// MitraStatistics.jsx
import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MitraStatistics = ({ data, formatCurrency }) => {
    // Demo data for the chart - in a real implementation this would come from the API
    const chartData = [
        { name: 'Jan', revenue: 2500000, bookings: 25 },
        { name: 'Feb', revenue: 3200000, bookings: 32 },
        { name: 'Mar', revenue: 4100000, bookings: 41 },
        { name: 'Apr', revenue: 3800000, bookings: 38 },
        { name: 'May', revenue: 4500000, bookings: 45 },
        { name: 'Jun', revenue: 5200000, bookings: 52 },
        { name: 'Jul', revenue: 4900000, bookings: 49 },
        { name: 'Aug', revenue: 5500000, bookings: 55 },
        { name: 'Sep', revenue: 5800000, bookings: 58 },
        { name: 'Oct', revenue: 6200000, bookings: 62 },
        { name: 'Nov', revenue: data.thisMonthRevenue || 6500000, bookings: data.completedBookings || 65 },
    ];

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Revenue & Booking Overview</h5>
                <div className="dropdown">
                    <button className="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                        This Year
                    </button>
                    <ul className="dropdown-menu">
                        <li><a className="dropdown-item" href="#">This Year</a></li>
                        <li><a className="dropdown-item" href="#">Last Year</a></li>
                        <li><a className="dropdown-item" href="#">Last 6 Months</a></li>
                    </ul>
                </div>
            </div>
            <div className="card-body">
                <div style={{ height: '320px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="name" tick={{ fill: '#666' }} />
                            <YAxis yAxisId="left" tick={{ fill: '#666' }} />
                            <YAxis yAxisId="right" orientation="right" tick={{ fill: '#666' }} />
                            <Tooltip 
                                formatter={(value, name) => [
                                    name === 'revenue' ? formatCurrency(value) : value,
                                    name === 'revenue' ? 'Revenue' : 'Bookings'
                                ]}
                            />
                            <Legend />
                            <Line 
                                yAxisId="left"
                                type="monotone" 
                                dataKey="revenue" 
                                name="Revenue" 
                                stroke="#8884d8" 
                                activeDot={{ r: 8 }} 
                            />
                            <Line 
                                yAxisId="right"
                                type="monotone" 
                                dataKey="bookings" 
                                name="Bookings" 
                                stroke="#82ca9d" 
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
};
export default MitraStatistics;
